import style from "./Inline.module.css";

function Inline(props) {
    const { weight, font, size, margin, color, padding } = props;
    return (
        <div className={style.inline} style={{
            fontWeight: weight,
            fontFamily: font,
            fontSize: size,
            margin: props.margin,
            color: color,
            padding: padding,
            width: props.width,
            textAlign: props.textAlign,
            display: props.display,
            alignItems: props.alignItems
        }}>
            {props.children}
        </div>
    );
}

export default Inline;